import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTimes,
  faThumbsUp,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";
import "../index.css";

export default function LandingPage(props) {
  return (
    <>
      <div className="">
        <div className="flex flex-wrap text-center justify-center pt-16">
          <div className="w-full lg:w-6/12 px-4">
            <h2 className="text-4xl font-bold text-600">Welcome!</h2>
            <p className="text-lg leading-relaxed mt-4 mb-4">
              Welcome to the "Residential Tenancy Agreement" form creation wizard. This tool allows you to create the form with the values you supply in the form fields.
              <span className="font-bold text-600"> The remainder of the Residential Tenancy Agreement and Condition Report is to be completed in hard copy with a pen.</span>
            </p>
            <p className="text-lg leading-relaxed mt-4 mb-4">
              The Forms Live Residential Tenancy Agreement package is available for only $66 (inc GST)
            </p>
          </div>
        </div>

        <div className="flex flex-wrap mt-20 justify-center">
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg bg-white rounded inline-flex items-center justify-center">
              <FontAwesomeIcon icon={faThumbsUp} size="2x" className="fill-current text-gray-600" />
            </div>
            <h6 className="text-xl mt-5 text-[#3059a9]">Easy to Use</h6>
            <p className="mt-2 mb-4">
              Interactive and user-friendly. Tried, tested and legally
              compliant.
            </p>
          </div>
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg rounded bg-white inline-flex items-center justify-center">
              <FontAwesomeIcon icon={faUserTimes} size="2x" className="fill-current text-gray-600" />
            </div>
            <h5 className="text-xl mt-5 text-[#3059a9]">No Subscription</h5>
            <p className="mt-2 mb-4">
              No Subscription required! Simply enter the required details, pay a
              one off fee and you're done!
            </p>
          </div>
          <div className="w-full lg:w-3/12 px-4 text-center">
            <div className="p-4 w-16 h-16 shadow-lg rounded inline-flex bg-white items-center justify-center">
              <FontAwesomeIcon icon={faBolt} size="2x" className="fill-current text-gray-600" />
            </div>
            <h5 className="text-xl mt-5 text-[#3059a9]">Fast!</h5>
            <p className="mt-2 mb-4">
              Complete in less than 2 minutes! We'll provide you with a download
              link sent to you via email.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap mt-20 justify-center">
          <button
            className="container bg-[#3059a9] hover:bg-[#31b7e6] text-white font-bold py-2 px-1 rounded-xl w-80"
            onClick={props.nextStep}
          >
            Let's get started
          </button>
        </div>
      </div>
    </>
  );
}
